import { render, staticRenderFns } from "./AttendeeTableTwoColumn.vue?vue&type=template&id=21f1ae26&scoped=true"
import script from "./AttendeeTableTwoColumn.vue?vue&type=script&lang=js"
export * from "./AttendeeTableTwoColumn.vue?vue&type=script&lang=js"
import style0 from "./AttendeeTableTwoColumn.vue?vue&type=style&index=0&id=21f1ae26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1ae26",
  null
  
)

export default component.exports